import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import { notifyError, notifySuccess } from '../../../../Common/UI/Notify';
import { Button } from '../../../../Common/UI/Button';
import EmailTagsInput from '../../../../Common/UI/EmailTagInput';

const SERVICE_ID = 'service_s5l2rxj';
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID!;
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY!;

const validateEmails = (emails: string[]): string | null =>
  emails.length === 0 ? 'At least one email is required' : null;

function EmailSender() {
  const [emails, setEmails] = useState<string[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const sendEmail = async (e: React.FormEvent) => {
    e.preventDefault();

    const validationError = validateEmails(emails);

    if (validationError) {
      setError(validationError);

      return;
    }
    setError(null);
    setLoading(true);

    try {
      await Promise.all(emails.map(email => emailjs.send(SERVICE_ID, TEMPLATE_ID, { email }, PUBLIC_KEY)));

      notifySuccess(`Email sent to ${emails.length} recipient(s)!`, 1500);
      setEmails([]);
    } catch {
      notifyError('Failed to send email.', 1500);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={sendEmail} className="flex flex-col gap-1 mb-4 max-w-xs">
      <div className="flex align-start gap-2">
        <EmailTagsInput
          emails={emails}
          onChange={e => {
            setEmails(e);
            setError(null);
          }}
          error={!!error}
        />
        <Button type="submit" size="sm" className="!bg-primary !text-white min-h-[37px]" disabled={loading}>
          Send
        </Button>
      </div>
      {error && <span className="text-red-500 text-xs pl-1">{error}</span>}
    </form>
  );
}

export default EmailSender;
